// Vendor libraries
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
// Modules
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
// Components
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
// Utils
import { toAlphaCase } from 'NewAngular/utils/string-utils';
import { SelectedItemOperationValue } from 'NewAngular/enums/selected-item-operation-value.enum';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../modals/confirm-modal/confirm-modal.component";
const _c0 = ["confirmModalComponent"];
const requiredItemAttrs = ['id', 'itemType', 'itemTypeDescription'];
function isDeleteModalItem(value) {
    return value && requiredItemAttrs.every((attr) => attr in value);
}
/**
 * A confirmation modal used for deleting an item of any type.
 */
export class DeleteModalComponent {
    set item(value) {
        if (value !== null && !isDeleteModalItem(value)) {
            throw Error(`ValueError. Item is missing required attributes: ${requiredItemAttrs}`);
        }
        this._item = value;
    }
    get item() {
        return this._item;
    }
    get confirmButtonText() {
        return this.item?.itemType === 'folder' ? `Delete Anyway` : 'Delete';
    }
    get confirmButtonClasses() {
        return this.item?.itemType === 'folder' ? 'btn-outline btn-danger' : 'btn-primary';
    }
    defaultConfirmationText() {
        if (this.item === null) {
            return '';
        }
        if (this.item.itemType === 'folder') {
            return ('The folder and the assets within the folder will be deleted. ' +
                'This action cannot be undone. Remove the assets from the folder to prevent deletion.');
        }
        return `Are you sure you want to delete this ${this.item.itemTypeDescription.toLowerCase()}?`;
    }
    constructor(store) {
        this.store = store;
        this.confirmText = '';
        this.deleteItemHandler = new EventEmitter();
        this._item = null;
        this.toAlphaCase = toAlphaCase;
    }
    ngAfterViewInit() {
        this.selectedOperationSubscription = this.getSelector().subscribe((selectedOperation) => {
            if (selectedOperation?.operation === SelectedItemOperationValue.DELETE) {
                this.item = selectedOperation.item;
                this.confirmText = this.confirmText || this.defaultConfirmationText();
                this.modal.openModal();
            }
        });
    }
    ngOnDestroy() {
        this.selectedOperationSubscription.unsubscribe();
    }
    getSelector() {
        switch (this.selectedOperationSlicePath.length) {
            case 1:
                return this.store.select(this.selectedOperationSlicePath[0]);
            case 2:
                return this.store.select(this.selectedOperationSlicePath[0], this.selectedOperationSlicePath[1]);
            default:
                throw new Error(`Unsupported select operation slice '${this.selectedOperationSlicePath}'`);
        }
    }
    confirmHandler(confirm) {
        if (confirm && this.item !== null) {
            this.deleteItemHandler.emit(this.item);
        }
    }
    closeModal() {
        this.item = null;
        this.confirmText = '';
        this.store.dispatch(this.clearSelectedOperationAction);
    }
}
DeleteModalComponent.ɵfac = function DeleteModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DeleteModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
DeleteModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DeleteModalComponent, selectors: [["ycn-delete-modal"]], viewQuery: function DeleteModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
    } }, inputs: { selectedOperationSlicePath: "selectedOperationSlicePath", clearSelectedOperationAction: "clearSelectedOperationAction", confirmText: "confirmText" }, outputs: { deleteItemHandler: "deleteItemHandler" }, decls: 2, vars: 5, consts: [["confirmModalComponent", ""], [3, "closeModalHandler", "confirmHandler", "confirmButtonText", "confirmButtonClasses", "confirmHeader", "confirmText", "modalTestId"]], template: function DeleteModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-confirm-modal", 1, 0);
        i0.ɵɵlistener("closeModalHandler", function DeleteModalComponent_Template_ycn_confirm_modal_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); })("confirmHandler", function DeleteModalComponent_Template_ycn_confirm_modal_confirmHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.confirmHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("confirmButtonText", ctx.confirmButtonText)("confirmButtonClasses", ctx.confirmButtonClasses)("confirmHeader", ctx.item === null ? "" : ctx.toAlphaCase(ctx.item.itemTypeDescription))("confirmText", ctx.confirmText)("modalTestId", ctx.item === null ? "" : ctx.item.itemTypeDescription.toLowerCase().split(" ").join("-"));
    } }, dependencies: [ConfirmModalModule, i2.ConfirmModalComponent], encapsulation: 2 });
